module.exports = __webpack_public_path__ + "img/prototypefund.69ae341c.png";